// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"ErrorBoundary__ErrorContainer__3aUo2","ErrorContent":"ErrorBoundary__ErrorContent__3_rTN"};